import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const BookIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M3.09963 2.75675C3.26933 1.946 3.9842 1.36526 4.81252 1.36526H12.0002C12.2228 1.36526 12.434 1.46423 12.5765 1.63537C12.719 1.80651 12.7781 2.03212 12.7377 2.25113L10.9877 11.7512C10.9134 12.1548 10.5288 12.423 10.1255 12.3549C10.0847 12.3617 10.0428 12.3653 10 12.3653H3.25C2.83579 12.3653 2.5 12.7011 2.5 13.1153C2.5 13.5295 2.83579 13.8653 3.25 13.8653H10.595C11.1952 13.8653 11.7106 13.4388 11.8229 12.8492L13.5132 3.97494C13.5908 3.56804 13.9834 3.30102 14.3903 3.37852C14.7972 3.45603 15.0643 3.84872 14.9868 4.25561L13.2964 13.1299C13.0494 14.4269 11.9154 15.3653 10.595 15.3653H3.25C2.00736 15.3653 1 14.358 1 13.1153C1 13.0619 1.00186 13.009 1.00552 12.9565C0.995775 12.877 0.998723 12.7945 1.01606 12.7117L3.09963 2.75675ZM5.35954 3.36526C5.14433 3.36526 4.95326 3.50298 4.8852 3.70715L4.71853 4.20715C4.61061 4.53091 4.85159 4.86526 5.19287 4.86526H9.13878C9.354 4.86526 9.54507 4.72755 9.61312 4.52338L9.77979 4.02337C9.88771 3.69961 9.64673 3.36526 9.30545 3.36526H5.35954Z"
		/>
	</svg>
))
